// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Updated CSS */
.sub-grid1, .sub-grid {
    max-height: 400px;
    overflow-y: auto;
    position: relative;
  }
  
  .sub-grid::-webkit-scrollbar {
    display: none;
  }
  /* 
  .table-container {
    overflow: auto;
    max-height: 100%;
  } */
  
  .select-table {
    width: 100%;
    border-collapse: collapse;
    position: relative;
  }
  
  .table-head {
    position: sticky;
    top: 0;
    z-index: 10;
  }
  
  .table-head th {
    position: sticky;
    top: 0;
    background: white;
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.1);
    z-index: 10;
  }
  
  /* Rest of your existing styles */
  .select-header {
    font-size: 24px !important;
    font-family: "Poppins" !important;
    font-weight: 500 !important;
  }
  
  .table-head th {
      font-family: "Karla";
      font-weight: 400;
      font-size: 18px;
      line-height: 21.04px;
      color: #000000;
      border-bottom: 1px solid black;
      border-right: 1px solid black;
      border-left: 1px solid black;
      padding: 8px;
      text-align: center;
      white-space: nowrap;
  }
  
  
  .table-body td {
    font-family: "Karla";
    font-weight: 400;
    font-size: 18px;
    line-height: 21.04px;
    color: #000000;
    border-bottom: 1px solid black;
    border-right: 1px solid black;
    border-left: 1px solid black;
    padding: 8px;
    text-align: center;
    white-space: nowrap;
  }
  
  .table-head th {
    font-weight: 500;
  }`, "",{"version":3,"sources":["webpack://./src/features/collection/components/Modal/Binnys_select_table/binnysSelectStyle.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;EACA;;;;KAIG;;EAEH;IACE,WAAW;IACX,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,iBAAiB;IACjB,6CAA6C;IAC7C,WAAW;EACb;;EAEA,iCAAiC;EACjC;IACE,0BAA0B;IAC1B,iCAAiC;IACjC,2BAA2B;EAC7B;;EAEA;MACI,oBAAoB;MACpB,gBAAgB;MAChB,eAAe;MACf,oBAAoB;MACpB,cAAc;MACd,8BAA8B;MAC9B,6BAA6B;MAC7B,4BAA4B;MAC5B,YAAY;MACZ,kBAAkB;MAClB,mBAAmB;EACvB;;;EAGA;IACE,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,cAAc;IACd,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB","sourcesContent":["/* Updated CSS */\n.sub-grid1, .sub-grid {\n    max-height: 400px;\n    overflow-y: auto;\n    position: relative;\n  }\n  \n  .sub-grid::-webkit-scrollbar {\n    display: none;\n  }\n  /* \n  .table-container {\n    overflow: auto;\n    max-height: 100%;\n  } */\n  \n  .select-table {\n    width: 100%;\n    border-collapse: collapse;\n    position: relative;\n  }\n  \n  .table-head {\n    position: sticky;\n    top: 0;\n    z-index: 10;\n  }\n  \n  .table-head th {\n    position: sticky;\n    top: 0;\n    background: white;\n    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.1);\n    z-index: 10;\n  }\n  \n  /* Rest of your existing styles */\n  .select-header {\n    font-size: 24px !important;\n    font-family: \"Poppins\" !important;\n    font-weight: 500 !important;\n  }\n  \n  .table-head th {\n      font-family: \"Karla\";\n      font-weight: 400;\n      font-size: 18px;\n      line-height: 21.04px;\n      color: #000000;\n      border-bottom: 1px solid black;\n      border-right: 1px solid black;\n      border-left: 1px solid black;\n      padding: 8px;\n      text-align: center;\n      white-space: nowrap;\n  }\n  \n  \n  .table-body td {\n    font-family: \"Karla\";\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 21.04px;\n    color: #000000;\n    border-bottom: 1px solid black;\n    border-right: 1px solid black;\n    border-left: 1px solid black;\n    padding: 8px;\n    text-align: center;\n    white-space: nowrap;\n  }\n  \n  .table-head th {\n    font-weight: 500;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
